import React, { Component } from 'react'
import Button from '@material-ui/core/Button'
import AccessAlarmIcon from '@material-ui/icons/AccessAlarm'
import Layout from '../../components/Layout'
import ListTable from './ListTable'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { contentActions, messageActions } from '../../actions'
import { crudListStyle } from '../../styles'
import CrudHeader from '../../components/CrudHeader'
import FilterSelect from '../../components/FilterSelect'
import UserToolbar from '../../components/UserToolbar'
import { specialities } from '../../api'
import CircularProgress from '@material-ui/core/CircularProgress'

class Keywords extends Component {
  state = {
    modalOpen: false
  }

  async componentWillUnmount() {
    const { resetState } = this.props
    resetState()
  }

  async componentDidMount() {
    const { getStatusContentReindex } = this.props
    await getStatusContentReindex()
  }

  render() {
    const {
      classes,
      token,
      newContent,
      reindexContents,
      getStatusContentReindex,
      changeMessage,
      jobStatus
    } = this.props

    const RightChildren = (
      <React.Fragment>
        <Button
          onClick={async () => {
            try {
              await reindexContents()

              const checkJobStatus = async () => {
                try {
                  const status = await getStatusContentReindex()

                  if (status === 'concluido') {
                    changeMessage('Os conteúdos foram processados.')
                  } else if (status === 'emAndamento') {
                    setTimeout(checkJobStatus, 60000)
                  } else {
                    changeMessage(
                      'Ocorreu um erro ao processar a solicitação. Tente novamente mais tarde.'
                    )
                  }
                } catch (error) {
                  changeMessage(
                    'Ocorreu um erro ao processar a solicitação. Tente novamente mais tarde.'
                  )
                }
              }

              checkJobStatus()
            } catch (exception) {
              changeMessage(
                'Ocorreu um erro ao processar a solicitação. Tente novamente mais tarde.'
              )
            }
          }}
          className={classes.newButton}
          variant="raised"
          color={'primary'}
          component={'a'}
          disabled={jobStatus === 'emAndamento'}
          style={{ width: '200px' }}
        >
          {jobStatus === 'emAndamento' ? (
            <React.Fragment>
              Processando... <CircularProgress size={16} style={{ marginLeft: '8px' }} />
            </React.Fragment>
          ) : (
            <React.Fragment>
              Atualizar tempos <AccessAlarmIcon className={classes.newButtonIcon} />
            </React.Fragment>
          )}
        </Button>
      </React.Fragment>
    )

    return (
      <Layout toolBarRight={UserToolbar}>
        <CrudHeader
          title={'Conteúdos'}
          classes={classes}
          newLink={'/conteudos/novo'}
          newLinkCallback={newContent}
          token={token}
          functionality={'conteudos'}
          rightChildren={RightChildren}
        >
          <FilterSelect
            placeholder="Selecione uma especialidade..."
            loadOptions={specialities.getSelectSpecialities}
          />
        </CrudHeader>
        <ListTable />
      </Layout>
    )
  }
}

const mapStateToProps = state => {
  return {
    modalOpen: state.keywords.modalOpen,
    token: state.auth.token,
    jobStatus: state.content.jobStatus
  }
}

const mapDispatchToProps = dispatch => {
  return {
    resetState: () => {
      dispatch(contentActions.resetState())
    },
    newContent: () => {
      dispatch(contentActions.newFormContent())
    },
    reindexContents: () => {
      return dispatch(contentActions.reindexContents())
    },
    getStatusContentReindex: id => {
      return dispatch(contentActions.getStatusContentReindex(id))
    },
    changeMessage: message => {
      dispatch(messageActions.changeMessage({ message }))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(crudListStyle)(Keywords))



// WEBPACK FOOTER //
// ./src/containers/Content/index.js